import React from 'react';
import ReactDOM, { render } from 'react-dom';
import { Provider } from 'react-redux';
import { createMemoryHistory } from 'history';

import registerServiceWorker from './registerServiceWorker';
import configureStore from './configureStore';
import processWidgetData from './utils/processWidgetData';

import Widget from './containers/Widget/Widget.jsx';

export const topLevelComponent = data => {
    const history = createMemoryHistory({
        basename: process.env.PUBLIC_URL
    });
    const store = configureStore(
        {
            widget: processWidgetData(data)
        },
        history
    );
    return (
        <Provider store={store}>
            <Widget history={history} />
        </Provider>
    );
};

export default function start(data, page, savedState, reset = false) {
    if (reset) {
        const el = document.getElementById(page.widgetContainerId);
        ReactDOM.unmountComponentAtNode(el);
    }

    const history = createMemoryHistory({
        basename: process.env.PUBLIC_URL
    });
    if (savedState && savedState.widgetId !== data.widgetId) savedState = null;
    let savedRoute = savedState && savedState.route;
    if (savedRoute){
        if (savedRoute.includes('/voteRegistration/step') && savedRoute.slice(-1) > 4) savedRoute = '/voteRegistration/step4';
        else if (savedRoute.includes('/donation')) savedRoute = '/donation/start';
        else if (savedRoute.includes('/email/multiRepStep2')) savedRoute = '/email';
    };
    const bounceDismissed = savedRoute ? true : false;
    const widgetData = Object.assign(
        {},
        {
            ...data,
            articleUrl: page.articleUrl,
            articleUrlTracking: page.articleUrlTracking,
            embedType: page.embedType,
            savedRoute,
            bounceDismissed,
        }
    );

    const widget = processWidgetData(widgetData, savedState);
    const cachedFormData = savedState ? savedState.cachedFormData : undefined;
    const mainStoreObject = {
            widget,
            cachedFormData
        };

    const savedActionData = savedState && savedState.savedResultData;
    if (savedActionData && savedRoute){
        const actionsWithSavedState = ['voteRegistration', 'volunteer'];
        const matchingAction = actionsWithSavedState.find(action => savedRoute.includes(action));
        if (matchingAction){
            mainStoreObject[matchingAction] = { ...savedActionData, isSubmitting:false };
        };
    };

    const store = configureStore(
        mainStoreObject,
        history
    );

    render(
        <Provider store={store}>
            <Widget history={history} />
        </Provider>,
        document.getElementById(page.widgetContainerId)
    );

    if (module.hot) {
        module.hot.accept('./containers/Widget/Widget.jsx', () => {
            render(
                <Provider store={store}>
                    <Widget history={history} />
                </Provider>,
                document.getElementById(page.widgetContainerId)
            );
        });
    }

    registerServiceWorker();
}
